import { inject, observer } from 'mobx-react'
import * as React from 'react'
import steps from '../../constants/steps'
import { ILayoutStore } from '../../store/LayoutStore'
import Step from '../Step/Step'
import Title from '../Title/Title'

interface IAppProps {
  LayoutStore?: ILayoutStore
}

@inject('LayoutStore')
@observer
class StepManager extends React.Component<IAppProps> {
  public constructor(props: IAppProps) {
    super(props)
  }

  public render() {
    return (
      <>
        {this.props.LayoutStore!.debugMode && (
          <p
            style={{
              backgroundColor: 'cyan',
              color: 'black',
              position: 'absolute',
              top: 0,
            }}
          >
            StepManager. Current Step: {this.props.LayoutStore!.currentStep}
            <br />
            Ariane Feed step : {this.props.LayoutStore!.arianeFeedStepCount}
          </p>
        )}

        <form action="">
          <div className="Row mainLogo">
            <Title>
              <p>Bienvenue</p>
              <p>sur l’alcoomètre</p>
            </Title>
          </div>

          {steps.map((stepDetails, stepCount) => {
            if (stepCount <= this.props.LayoutStore!.currentStep) {
              return (
                <Step
                  key={stepDetails.componentName}
                  stepCount={stepCount}
                  componentName={stepDetails.componentName}
                  autoValidate={stepDetails.autoValidate}
                  isArianeFeedStep={stepDetails.isArianeFeedStep}
                  isSkippable={stepDetails.isSkippable || false}
                  defaultValidate={stepDetails.defaultValidate || false}
                  checkConsumptionDays={stepDetails.checkConsumptionDays || false}
                />
              )
            } else {
              return
            }
          })}
        </form>
      </>
    )
  }
}

export default StepManager



// WEBPACK FOOTER //
// ./src/components/StepManager/StepManager.tsx